export const chartOptions = {
  options: {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    elements: {
      point: {
        radius: 2,
        pointBackgroundColor: 'white',
      },
    },
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            fontColor: '#8e9fad',
          },
          display: true,
          color: '#667278',
          gridLines: {
            display: true,
            color: '#f2f2f2',
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            fontColor: '#8e9fad',
          },
          display: true,
          color: '#667278',
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: false,
            labelString: 'Tarih',
          },
        },
      ],
    },
  },
};

export default chartOptions;
